import APIService, { withPrefix } from "@/services/APIService";
import JSONApiService from "@/services/JSONApiService";
import { USER_MODEL } from "@/models/user-model";
import { APPLICATION_MODEL } from "@/models/application-model";
import { INTERVIEW_FORMAT_MODEL } from "@/models/interview-format-model";
import {
  include,
  ORGANISATIONS,
  EVENTS,
  ADDRESSES,
  APPLICATIONS,
  INTERVIEW_SLOTS,
  INTERMEDIARY_ORGANISATION,
  USER,
  BOOKING,
  COMPLIANCE_CHECKS,
  REFERENCES,
  nested,
  LOCATION,
  CONVERSATIONS,
  OFFERS,
  LAST_MESSAGE,
  APPLICATION,
  WORKING_HOURS_GROUPINGS,
  CONTRACT_TYPES_GROUPINGS
} from "@/models/relationships";
import { ORGANISATION_MODEL } from "@/models/organisation-model";
import { EXPERIENCE_FUNCTION_MODEL } from "@/models/experience-function-model";
import { LOCATION_GROUPING_MODEL } from "@/models/location-grouping-model";
import pluralize from "pluralize";

const API = withPrefix(APIService.client(), "users");

const workersApi = ({ commit } = {}) => ({
  getAllWorkers: async params =>
    JSONApiService(commit)
      .all(USER)
      .get({
        ...params,
        ...include(ORGANISATION_MODEL, APPLICATIONS, INTERVIEW_SLOTS, OFFERS)
      }),
  deleteWorker: async id => API.delete(`${id}`),
  getIntermediaryCompany: async id =>
    API.get(`${id}/intermediary-organisation?include=addresses`),
  addNewWorker: async data => {
    const password = process.env.VUE_APP_WORKER_DEFAULT_PASSWORD;
    return JSONApiService(commit).create(
      USER_MODEL,
      {
        password,
        ...data
      },
      include(COMPLIANCE_CHECKS, ADDRESSES)
    );
  },
  updateWorker: async data => {
    return JSONApiService(commit).update(
      USER_MODEL,
      data,
      include(
        ADDRESSES,
        ORGANISATIONS,
        INTERMEDIARY_ORGANISATION,
        EVENTS,
        COMPLIANCE_CHECKS,
        REFERENCES
      )
    );
  },
  getWorker: async id =>
    JSONApiService(commit).find(
      USER_MODEL,
      id,
      include(
        ADDRESSES,
        APPLICATIONS,
        CONVERSATIONS,
        OFFERS,
        INTERVIEW_SLOTS,
        nested(APPLICATIONS, BOOKING),
        nested(INTERVIEW_SLOTS, INTERVIEW_FORMAT_MODEL),
        nested(OFFERS, APPLICATION, BOOKING),
        nested(CONVERSATIONS, LAST_MESSAGE),
        pluralize(EXPERIENCE_FUNCTION_MODEL),
        pluralize(LOCATION_GROUPING_MODEL),
        pluralize(WORKING_HOURS_GROUPINGS),
        pluralize(CONTRACT_TYPES_GROUPINGS)
      )
    ),
  getApplications: async ({ params }) =>
    JSONApiService(commit)
      .all(APPLICATION_MODEL)
      .get({ ...params, ...include(BOOKING, nested(BOOKING, LOCATION), USER) }),
  deleteWorkerCV: async id => API.delete(`${id}/cv`),
  deleteWorkerComplianceDocument: async id =>
    API.delete(`${id}/compliance-document`)
});

export default workersApi;
